import React, { useContext, useEffect, useState } from "react";
import Fade from "react-reveal/Fade";
import Tilt from "react-tilt";
import { Container, Row, Col } from "react-bootstrap";
import PortfolioContext from "../../context/context";
import Title from "components/booth/title";
import event_img from "img/event_img.jpeg";
import Image from "react-bootstrap/Image";

import Paper from "@material-ui/core/Paper";

const Projects = () => {
  const { departmentObj } = useContext(PortfolioContext);
  const { event } = departmentObj;
  const [isDesktop, setIsDesktop] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    if (window.innerWidth > 769) {
      setIsDesktop(true);
      setIsMobile(false);
    } else {
      setIsMobile(true);
      setIsDesktop(false);
    }
  }, []);

  return (
    <>
      <section
        id="about"
        className={departmentObj.key}
        style={{ backgroundColor: "white" }}
      >
        <Container>
          <div className="about-wrapper">
            {/* <Title title="이벤트 소개" /> */}
            <Title title="이벤트가 종료되었습니다!" />
            <Title title="참여해주신 여러분 정말 감사합니다~!!" />
          </div>
        </Container>
      </section>
      <section
        id="projects"
        className={departmentObj.key}
        style={{ backgroundColor: "white" }}
      >
        <Container>
          <div className="project-wrapper">
            {/* <Title title="이벤트 소개" /> */}
            <Title title="The End" />
            {/* <Title title="2주차에 봬요!!" /> */}
          </div>
        </Container>
      </section>
    </>
  );
};

export default Projects;
